import { WebIO } from "@gltf-transform/core";
import { MESH_COLLIDER_MAX_TRIANGLES } from "../engine/colliderRules";

export interface Precheck { ok: boolean; problems: string[]; triangles: number; textures: number; nodes: number }

const DEFAULTS = { triangles: MESH_COLLIDER_MAX_TRIANGLES, textures: 8, nodes: 500, bytes: 20 << 20 };

/** The over-the-cap line, pointing at the guide that shows how to simplify or split (spec 2l §4.2). */
export function trianglesProblem(n: number, limit: number, host: string): string {
  return `三角形 ${n} 超過上限 ${limit.toLocaleString("en-US")}：請先減面或切塊，做法見 ${host}/skills/assets/glb-prep`;
}

export async function precheckGLB(buf: ArrayBuffer, limits = DEFAULTS, host = globalThis.location?.host ?? "nomen.land"): Promise<Precheck> {
  const problems: string[] = [];
  if (buf.byteLength > limits.bytes) problems.push(`檔案 ${(buf.byteLength / 1048576).toFixed(1)} MB 超過上限 ${limits.bytes >> 20} MB`);
  const magic = buf.byteLength >= 4 ? new DataView(buf).getUint32(0, true) : 0;
  if (magic !== 0x46546c67) return { ok: false, problems: ["不是 GLB 檔案"], triangles: 0, textures: 0, nodes: 0 };
  let triangles = 0, textures = 0, nodes = 0;
  try {
    const doc = await new WebIO().readBinary(new Uint8Array(buf));
    const root = doc.getRoot();
    for (const mesh of root.listMeshes()) for (const prim of mesh.listPrimitives()) {
      const idx = prim.getIndices();
      const pos = prim.getAttribute("POSITION");
      const count = idx ? idx.getCount() : pos ? pos.getCount() : 0;
      triangles += Math.floor(count / 3);
    }
    textures = root.listTextures().length;
    nodes = root.listNodes().length;
    for (const b of root.listBuffers()) if (b.getURI() && !b.getURI().startsWith("data:")) problems.push("GLB 引用外部 buffer");
    for (const t of root.listTextures()) if (t.getURI() && !t.getURI().startsWith("data:")) problems.push("GLB 引用外部貼圖");
  } catch (e) {
    problems.push("無法解析：" + String(e));
  }
  if (triangles > limits.triangles) problems.push(trianglesProblem(triangles, limits.triangles, host));
  if (textures > limits.textures) problems.push(`貼圖 ${textures} 張超過上限 ${limits.textures}`);
  if (nodes > limits.nodes) problems.push(`節點 ${nodes} 超過上限 ${limits.nodes}`);
  return { ok: problems.length === 0, problems, triangles, textures, nodes };
}
